<script>
import drawer from '@/components/drawer';
import transitionFade from '@/components/transition/fade.vue';
import store from '../../store';
export default {
    props: {
        status: {
            type: Boolean
        }
    },
    computed: {
        list() {
            return store.specList;
        },
        checked() {
            return store.form.spec.id;
        }
    },
    methods: {
        change(id, name) {
            store.form.spec.id = id;
            store.form.spec.name = name;
            this.$emit('update:status', false);
        }
    },
    components: {
        drawer,
        transitionFade
    }
}
</script>

<template>
    <drawer 
        :status="status" 
        :clickShadowAutoClose="true"
        @update:status="$emit('update:status', $event)"
    > 
        <div class="sidebar-container">
            <div class="header">
                <h4>请选择车型</h4>
                <span @click="$emit('update:status', false)">返回</span>
            </div>
            <div class="content">
                <ul>
                    <li
                        v-for="item in list"
                        :data-id="item.specId"
                        @click="change(item.specId, item.specName)"
                    >
                        {{item.specName}}
                        <transition-fade>
                            <i v-if="item.specId === checked"></i>
                        </transition-fade>
                    </li>
                </ul>
            </div>
        </div>
    </drawer>
</template>

<style lang="stylus" scoped>
.sidebar-container
    display flex
    flex-direction column
    height 100%
    background-color #fff
.header
    position relative
    height 2.13rem
    line-height 2.13rem
    background linear-gradient(135deg,rgba(255,168,0,1) 0%,rgba(255,60,0,1) 100%)
    background-color #ff3c00
    h4
        font-size .8rem
        font-weight normal
        color #fff
    span
        position absolute
        top 0
        bottom 0
        left 0
        padding 0 0.64rem
        font-size 0.64rem
        color #fff
        cursor pointer
.content
    flex 1
    overflow-x hidden
    overflow-y auto
    ul
        font-size 0.746rem
    li
        position relative
        padding 0.53rem 2.13rem 0.53rem 0.53rem
        line-height 1.2
        text-align left
        border-bottom 0.053rem solid #eee
        word-break keep-all
        cursor pointer
    li i
        position absolute
        top 0
        bottom .2rem
        right 0.8rem
        margin auto
        width .34rem
        height .6rem
        background-color transparent
        border 0.14rem solid #ff3c00
        border-left 0
        border-top 0
        transform-origin center
        transform rotateZ(45deg)
</style>